
import React, { useEffect, useState, useContext, Fragment } from 'react';
import {isNumeric,isMonthAndYearEmpty,getStatusFlagValue,getButtonDisabledStates,shortMonthToMonthNumber} from '../Custom/Custom'
import messages from '../assets/Messages.json'
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from '../Constant';
import { GlobalLoading, showLoading } from 'react-global-loading'

function MiningAndElectricitySectorData({
  config,
  resetFormData,
  userInfoObject,
  yearName,
  monthName,
  allSectorData,
  url,
  type,
  payload,
  storedLanguage,
  titlesData
}) {


  
  const navigate = useNavigate();
  const [itemData, setItemData] = useState({});
  const [isCoal, setIsCoal] = useState(false);
  const [isPyrophyllite, setIsPyrophyllite] = useState(false);
  const [isDiaspore, setIsDiaspore] = useState(false);
  const [isSilicasand, setIsSilicasand] = useState(false);
  const [isLimestone, setIsLmestone] = useState(false);

  const {
    isSaveBtnDisable,
    isAcceptBtnDisable,
    } = getButtonDisabledStates(payload, userInfoObject);

  let isDisable=false;





 const itemactbaseYear=()=>{
  
  let selectYear=parseInt(yearName)
  let selectMonth=shortMonthToMonthNumber(monthName)
  var baseYear='';


if(selectYear===2018 && selectMonth>='04')
		  {
		  baseYear=2011;
		  }else if(selectYear>2018)
		  {
			  baseYear=2011;
			  }if(selectYear===2018 && selectMonth<'04')
			  {
				  baseYear=2004;
				  }if(selectYear<2018 )
				  {
					    baseYear=2004;
					  } if(selectYear==='')
						  {
						  alert(11)
						  baseYear="";
						  }
				  
				  if(baseYear===2004)
					  {
              setIsCoal(true);
              setIsPyrophyllite(true);
              setIsDiaspore(true);
              setIsSilicasand(true);
              setIsLmestone(false)
        
 
					  }else if(baseYear===2011)
						  {
			
              setIsCoal(true);
              setIsPyrophyllite(false);
              setIsDiaspore(false);
              setIsSilicasand(false);
              setIsLmestone(true)
						  }
				  if(baseYear==='')
					  {
				
            setIsCoal(false);
            setIsPyrophyllite(false);
            setIsDiaspore(false);
            setIsSilicasand(false);
            setIsLmestone(false)
					  }
  }


  
 


 // Table Header
 const renderHeader = (i) => (
  <thead key={`thead-${i}`}>
    <tr>
    <th className="text-center">{storedLanguage === 'hi' ? titlesData.hi.ITEM_CODE : titlesData.en.ITEM_CODE}</th>
    <th className="text-center">{storedLanguage === 'hi' ? titlesData.hi.UNIT : titlesData.en.UNIT}</th>
    <th className="text-center">{storedLanguage === 'hi' ? titlesData.hi.QUANTITY_PRODUCED : titlesData.en.QUANTITY_PRODUCED}</th>
     </tr>
  </thead>
); 


//handle  onChange
const handleOnChange = (itemCode, field, newValue) => {

  if (!isNumeric(newValue)) {
    toast.error(messages.NUMERIC_MSG, messages.COLOR_RED);
    newValue = '';
  }

  setItemData(prevItemData => {
    const updatedItemData = {
      ...prevItemData,
      [itemCode]: {
        ...prevItemData[itemCode],
        [field]: newValue,
      }
    };

    return updatedItemData;
  });


};



useEffect(() => {
  itemactbaseYear();
  const initialData = {};

  allSectorData.forEach(item => {
       initialData[0] = {
        coalProducedName:item.coalProducedName,
        coalProducedUnit:item.coalProducedUnit,
        coalProduced:item.coalProduced,

        pyrophylliteName:item.pyrophylliteName,
        pyrophylliteUnit:item.pyrophylliteUnit,
        pyrophylliteProduced:item.pyrophylliteProduced,

        diasporeName:item.diasporeName,
        diasporeUnit:item.diasporeUnit,
        diasporeProduced:item.diasporeProduced,

        silicasandName:item.silicasandName,
        silicasandUnit:item.silicasandUnit,
        silicaSandProduced:item.silicaSandProduced,

        limestoneProducedName:item.limestoneProducedName,
        limestoneProducedUnit:item.limestoneProducedUnit,
        limestoneProduced:item.limestoneProduced,



          limestoneproduced:item.limestoneproduced, //unique
          itemCoal: item.itemCoal,
          itemLIMESTONE:item.itemLIMESTONE,
          statusFlag:item.statusFlag,
 
          
          Unit:item.Unit,
          electricityproduced:item.electricityproduced,
          itemElectricity:item.itemElectricity,
          
          //  remark:item.remark,
     
          style: {
            borderColor: 'rgb(220, 223, 225) rgb(220, 223, 225) rgb(220, 223, 225) black',
            borderStyle: 'solid',
            borderWidth: '1px 1px 1px 3px'
          },
          isRequiredRemark:false,
          isRejectStatus:false
          
        };
    
  });
  
 setItemData(initialData);
}, [allSectorData]);



const handleSaveSectorData=async(e,buttonType)=>{
    let clickButtonStatusFlag = getStatusFlagValue(buttonType, userInfoObject.userLevel); //button click status flag
 
    let postData='';
  
  

   if(type==='MiningSector'){

      
      if(itemData[0].coalProduced==='' || itemData[0].limestoneProduced===''){
        toast.error("Quantity Produced is mandatory.", messages.COLOR_RED);
        return false;
      }
        const customObject = {
          coalProducedName:itemData[0].coalProducedName,
          coalProducedUnit:itemData[0].coalProducedUnit,
          coalProduced:itemData[0].coalProduced ? itemData[0].coalProduced : "0.00",

          pyrophylliteName:itemData[0].pyrophylliteName,
          pyrophylliteUnit:itemData[0].pyrophylliteUnit,
          pyrophylliteProduced:itemData[0].pyrophylliteProduced ? itemData[0].pyrophylliteProduced : "0.00",
          
          diasporeName:itemData[0].diasporeName,
          diasporeUnit:itemData[0].diasporeUnit,
          diasporeProduced:itemData[0].diasporeProduced ? itemData[0].diasporeProduced : "0.00",
         
          silicasandName:itemData[0].silicasandName,
          silicasandUnit:itemData[0].silicasandUnit,
          silicaSandProduced:itemData[0].silicaSandProduced ? itemData[0].silicaSandProduced : "0.00",
          
          limestoneProducedName:itemData[0].limestoneProducedName,
          limestoneProducedUnit:itemData[0].limestoneProducedUnit,
          limestoneProduced:itemData[0].limestoneProduced ? itemData[0].limestoneProduced : "0.00",
          statusFlag:clickButtonStatusFlag,
         
        
        };
        postData = {
          itemCodes: [customObject],
          payload: {
            month: monthName,
            year: yearName,
            buttonType: buttonType,
            statusButtonFlag:clickButtonStatusFlag
              
          }
      };
   }else if(type==='ElectricitySector'){

          if(itemData[0].electricityproduced===''){
              toast.error("Quantity Produced is mandatory.", messages.COLOR_RED);
              return false;
          }
      
    
          const customObject = {
            electricityproduced:itemData[0].electricityproduced ? itemData[0].electricityproduced : "0.00",
           statusFlag:clickButtonStatusFlag,
          };
          postData = {
            itemCodes: [customObject],
            payload: {
              month: monthName,
              year: yearName,
              buttonType: buttonType,
              statusButtonFlag:clickButtonStatusFlag
                
            }
        };
   }
    

    showLoading(true)
	try {
	   const response = await axios.post(`${API_URL}api/${url}`, postData, config);
   if (response.data.status) {
	   toast.success(response.data.message, messages.COLOR_RED);
	 }else{
     toast.error(response.data.message, messages.COLOR_RED);
   }
   } catch (error) {
	   console.error(error);
	   toast.error('An error occurred while processing your request.', messages.COLOR_RED);
   } finally {
		showLoading(false);
    resetForm()
		
   }

}

//reset Form
const resetForm=()=>{
  resetFormData()
  const initialData = {};

  allSectorData.forEach(item => {
       initialData[0] = {
        coalProducedName:item.coalProducedName,
        coalProducedUnit:item.coalProducedUnit,
        coalProduced:'',

        pyrophylliteName:item.pyrophylliteName,
        pyrophylliteUnit:item.pyrophylliteUnit,
        pyrophylliteProduced:'',

        diasporeName:item.diasporeName,
        diasporeUnit:item.diasporeUnit,
        diasporeProduced:'',

        silicasandName:item.silicasandName,
        silicasandUnit:item.silicasandUnit,
        silicaSandProduced:'',

        limestoneProducedName:item.limestoneProducedName,
        limestoneProducedUnit:item.limestoneProducedUnit,
        limestoneProduced:'',



          limestoneproduced:'', //unique
          itemCoal: item.itemCoal,
          itemLIMESTONE:item.itemLIMESTONE,
          statusFlag:item.statusFlag,
 
          
          Unit:item.Unit,
          electricityproduced:'',
          itemElectricity:item.itemElectricity,
          
          //  remark:item.remark,
     
         
          isRequiredRemark:false,
          isRejectStatus:false
          
        };
    
  });
  
 setItemData(initialData);
  
  }

  return (
    <>
    {/* <ToastContainer/> */}
    <div className="card-body">
        <div className="table-responsive">
          <table  className="table table-bordered">
            {renderHeader(0)}
            <tbody>
           {allSectorData && allSectorData.map((item,i)=>{

            if( payload.statusFlagSet === "6" && isAcceptBtnDisable){
                isDisable =true
             } else if(isAcceptBtnDisable){
                isDisable =true
            }

              return (
                <>

                      {/* MiningSector HTML */}
                    { type==='MiningSector' && 
                      <>

                          {/* coalProducedName   */}
                          {isCoal &&
                            <tr key={i}>
                                  

                                   <td>{storedLanguage === 'hi' ? titlesData.hi.COAL : itemData[0]?.coalProducedName}</td>
                                   <td>{storedLanguage === 'hi' ? titlesData.hi.MT : itemData[0]?.coalProducedUnit}</td>

                                  <td>
                                    <input
                                      type='text'
                                      className="form-control"
                                      name={`coalProduced${i}`}
                                      id={`coalProduced${i}`}
                                      maxLength="12"
                                      value={itemData[0]?.coalProduced}
                                      onChange={e => handleOnChange(0, 'coalProduced', e.target.value)} />

                                  </td>



                            </tr>
                          }


                          {/* pyrophylliteName   */}
                          {isPyrophyllite &&
                          <tr key={i}>
                                  

                                  <td>{itemData[0]?.pyrophylliteName}</td>
                                  <td> {itemData[0]?.pyrophylliteUnit}  </td>

                                  <td>
                                    <input
                                      type='text'
                                      className="form-control"
                                      name={`pyrophylliteProduced${i}`}
                                      id={`pyrophylliteProduced${i}`}
                                      maxLength="12"
                                      value={itemData[0]?.pyrophylliteProduced}
                                      onChange={e => handleOnChange(0, 'pyrophylliteProduced', e.target.value)} />


                                  </td>



                          </tr>
                          }
                             
                         {/* diasporeName   */}
                         {isDiaspore &&
                            <tr key={i}>
                                   
                                    <td>{itemData[0]?.diasporeName} </td>
                                    <td>{itemData[0]?.diasporeUnit} </td>

                                    <td>
                                      <input
                                        type='text'
                                        className="form-control"
                                        name={`diasporeProduced${i}`}
                                        id={`diasporeProduced${i}`}
                                        maxLength="12"
                                        value={itemData[0]?.diasporeProduced}
                                        onChange={e => handleOnChange(0, 'diasporeProduced', e.target.value)} />


                                    </td>



                            </tr>
                          }

                          {/* silicasandName   */}
                          {isSilicasand &&
                            <tr key={i}>
                                   

                                    <td>{itemData[0]?.silicasandName}  </td>
                                   <td>{itemData[0]?.silicasandUnit}  </td>

                                    <td>
                                      <input
                                        type='text'
                                        className="form-control"
                                        name={`silicaSandProduced${i}`}
                                        id={`silicaSandProduced${i}`}
                                        maxLength="12"
                                        value={itemData[0]?.silicaSandProduced}
                                        onChange={e => handleOnChange(0, 'silicaSandProduced', e.target.value)} />


                                    </td>



                            </tr>
                           }
       
                            {/* limestoneProducedName   */}
                            {isLimestone &&
                              <tr key={i}>
                                     
                                      <td>{itemData[0]?.limestoneProducedName}</td>

                                      <td>{storedLanguage === 'hi' ? titlesData.hi.MT : itemData[0]?.limestoneProducedUnit}</td>

                                      <td>
                                        <input
                                          type='text'
                                          className="form-control"
                                          name={`limestoneProduced${i}`}
                                          id={`limestoneProduced${i}`}
                                          maxLength="12"
                                          value={itemData[0]?.limestoneProduced}
                                          onChange={e => handleOnChange(0, 'limestoneProduced', e.target.value)} />


                                      </td>



                              </tr>
                           }
                    </>
                    }


                    {/* Electricity Sector HTML */}
                    { type==='ElectricitySector' && 
                        <>
                        <tr key={i}>
                             
                              <td>
                              {storedLanguage === 'hi' ? titlesData.hi.ELECTRICITY : itemData[0]?.itemElectricity}
                              
                                <input
                                  type='hidden'
                                  className="form-control"
                                  name={`itemElectricity${i}`}
                                  id={`itemElectricity${i}`}
                                  value={itemData[0]?.itemElectricity}
                                  disabled />
                              </td>

                              <td>
                              {itemData[0]?.Unit}
                                <input
                                  type='hidden'
                                  className="form-control"
                                  name={`Unit${i}`}
                                  id={`Unit${i}`}
                                  disabled
                                  value={itemData[0]?.Unit} />
                              </td>

                              <td>
                                <input
                                  type='text'
                                  className="form-control"
                                  name={`electricityproduced${i}`}
                                  id={`electricityproduced${i}`}
                                  maxLength="12"
                                  value={itemData[0]?.electricityproduced}
                                  onChange={e => handleOnChange(0, 'electricityproduced', e.target.value)} />


                              </td>



                        </tr>
                        </>
                      }


                </>
                        
                )})

           }
               
           </tbody>
        </table>
          </div>

        <div className="row">
          <div className="col-12 text-center pt-3">
              {
              <button
                onClick={(e) => handleSaveSectorData(e, 'SAVE')}
                type="button"
                className={`btn btn_orange mx-1 ${isSaveBtnDisable?'disabled':''}`} 
              >Save
              </button>
              }
               
               { 
                (userInfoObject.userLevel==='HEAD QUARTER') && 
                <>
              
                <button 
                onClick={(e)=>handleSaveSectorData(e,'ACCEPT')}   
                type="button" 
                className={`btn btn_orange mx-1 ${isDisable? 'disabled':''}`}
                >Accept
                </button>
                </>
               }
          

              <button 
                type="reset" 
                className="btn btn_orange mx-1" 
                onClick={resetForm} 
                >
                Reset
              </button>

              <button 
                type="button" 
                className="btn btn_orange mx-1" 
                onClick={(e)=>( navigate("/dashboard"))}
                >
                Cancel
              </button>
          </div>
        </div>

        </div>
      </>
  )
}

export default MiningAndElectricitySectorData